import React from 'react';
import PropTypes from 'prop-types';
import './BlogLink.scss';

const BlogLink = ({ url, image, style, target, text }) => (
  <a
    href={url}
    className={`cms-link--${style} ${image && 'cms-link--image'}`}
    target={target ? '_blank' : '_self'}
  >
    {image ? <img src={image} alt={text} /> : text}
  </a>
);

BlogLink.propTypes = {
  url: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  style: PropTypes.string.isRequired,
  target: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
};

export default BlogLink;
